const locales = {};

['de', 'en', 'es', 'fr', 'ja', 'pt', 'zh'].forEach((locale) => {
  Object.assign(locales, require(`./${locale}.yml`));
});

export default locales;
